import { useT } from "../router/Router";

const Status = ({ status }: any) => {
    const t = useT();

    return status === "loading" ? (
        <span style={{ color: "#ffffff53" }}>
            {t("loading_status")}
            <div className="loader"></div>
        </span>
    ) : status === true ? (
        <span style={{ color: "#25cc69" }}>
            {t("success_status")}
            <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                width="15px"
                viewBox="-3.5 0 19 19"
            >
                <path d="M4.63 15.638a1.028 1.028 0 0 1-.79-.37L.36 11.09a1.03 1.03 0 1 1 1.58-1.316l2.535 3.043L9.958 3.32a1.029 1.029 0 0 1 1.783 1.03L5.52 15.122a1.03 1.03 0 0 1-.803.511.89.89 0 0 1-.088.004z" />
            </svg>
        </span>
    ) : status === false ? (
        <span style={{ color: "#ee4849" }}>
            {t("error_status")}
            <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                width="15px"
                viewBox="-3.5 0 19 19"
            >
                <path d="M11.383 13.644A1.03 1.03 0 0 1 9.928 15.1L6 11.172 2.072 15.1a1.03 1.03 0 1 1-1.455-1.456l3.928-3.928L.617 5.79a1.03 1.03 0 1 1 1.455-1.456L6 8.261l3.928-3.928a1.03 1.03 0 0 1 1.455 1.456L7.455 9.716z" />
            </svg>
        </span>
    ) : (
        <span style={{ color: "#e56419" }}>
            {t("no_info_status")}
            <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                width="15px"
                viewBox="0 0 512 400"
                version="1.1"
                fill="currentColor"
            >
                <path
                    xmlns="http://www.w3.org/2000/svg"
                    d="M246.312928,5.62892705 C252.927596,9.40873724 258.409564,14.8907053 262.189374,21.5053731 L444.667042,340.84129 C456.358134,361.300701 449.250007,387.363834 428.790595,399.054926 C422.34376,402.738832 415.04715,404.676552 407.622001,404.676552 L42.6666667,404.676552 C19.1025173,404.676552 7.10542736e-15,385.574034 7.10542736e-15,362.009885 C7.10542736e-15,354.584736 1.93772021,347.288125 5.62162594,340.84129 L188.099293,21.5053731 C199.790385,1.04596203 225.853517,-6.06216498 246.312928,5.62892705 Z M224,272 C208.761905,272 197.333333,283.264 197.333333,298.282667 C197.333333,313.984 208.415584,325.248 224,325.248 C239.238095,325.248 250.666667,313.984 250.666667,298.624 C250.666667,283.264 239.238095,272 224,272 Z M245.333333,106.666667 L202.666667,106.666667 L202.666667,234.666667 L245.333333,234.666667 L245.333333,106.666667 Z"
                ></path>
            </svg>
        </span>
    );
};

export default Status;
